import { JHADesignerEngine } from "..";
import { observeOnceToPromise } from "../utilities";
import { TextureAssetTask, AssetTaskState } from "@babylonjs/core/Misc/assetsManager";

export class TextureBulkUpdateManager {
  private _textureTasks: { [name:string]: Promise<TextureAssetTask> } = {};
  private _runPromise?: Promise<void>;

  constructor(public readonly engine: JHADesignerEngine) {
  }

  prepare() {
    if ( this._runPromise ) {
      return;
    }

    this._textureTasks = {};
    this.engine.assetsManager.reset();
  }

  load(name: string, uri: string) {
    if ( !Reflect.has(this._textureTasks, uri) ) {
      const task = this.engine.assetsManager.addTextureTask(name, uri)
      this._textureTasks[uri] = new Promise(async (resolve, reject) => {
        this.engine.assetsManager.onTaskSuccessObservable.addOnce(() => {
          resolve(task);
        });
        this.engine.assetsManager.onTaskErrorObservable.addOnce(() => {
          if ( task.taskState === AssetTaskState.DONE ) {
            resolve(task);
            return;
          }

          if ( task.taskState === AssetTaskState.ERROR ) {
            console.dir(task.errorObject);
            reject(task);
          }
        });
      })
    }

    return this._textureTasks[uri];
  }

  async commit() {
    if ( Object.values(this._textureTasks).length == 0) {
      return;
    }

    if ( this._runPromise ) {
      await this._runPromise;
      return;
    }

    this._runPromise = this._waitForTasks();
    await this._runPromise;
    this._runPromise = undefined;
  }

  async _waitForTasks() {
    const success = observeOnceToPromise(this.engine.assetsManager.onTaskSuccessObservable);
    await this.engine.assetsManager.loadAsync();
    await success;
  }
}